import { forwardRef, useState } from "react";
import { submitFeedback } from "../../api/firebase/live-chat";
import Button from "../Button";
import ChevronLeft from "../Icons/ChevronLeft";
import CircleCheckBig from "../Icons/CircleCheckBig";
import ThumbsDown from "../Icons/ThumbsDown";
import ThumbsUp from "../Icons/ThumbsUp";
import { clearChatLocalStorage } from "../../lib/helper/clearChatLocalStorage";

export const EndChat = forwardRef(
  (
    {
      onEndChat,
      brandPrimaryColor,
      apiKey,
      chatId,
      orgId,
      isAgentAssigned,
      handleCloseChat,
      handleBackToChat,
      userAgentDetails,
      isDisconnectChatLoading,
      isChatCompleted,
    },
    ref
  ) => {
    const [isFeedbackGiven, setIsFeedbackGiven] = useState(false);
    const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);

    const customerName = JSON.parse(
      localStorage.getItem("userDetails")
    )?.customer_name;
    const agentName = localStorage.getItem("agentName")?.split(" ")[0];

    const handleFeedback = async (value, currentChatId, currentOrgId) => {
      setIsFeedbackLoading(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("x-api-key", apiKey);

        const getAnswerRequestOptions = {
          method: "POST",
          headers: myHeaders,
          redirect: "follow",
        };

        const response = await submitFeedback(
          currentOrgId,
          currentChatId,
          value,
          getAnswerRequestOptions
        );

        if (response.type === "Success") {
          setIsFeedbackGiven(true);
          onEndChat(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsFeedbackLoading(false);
      }
    };

    const onHover = (e) => {
      const element = e.currentTarget.style;
      element.backgroundColor = brandPrimaryColor;
      element.color = "white";
    };

    const onLeave = (e) => {
      const element = e.currentTarget.style;
      element.backgroundColor = "transparent";
      element.color = brandPrimaryColor;
    };

    return (
      <div className="curai-box-border curai-p-5 curai-flex curai-justify-between curai-items-center curai-flex-col curai-h-full curai-w-full">
        {isFeedbackGiven ? (
          <div className=" curai-flex curai-place-content-center curai-flex-col curai-bg-white curai-h-full curai-text-center curai-py-2">
            <CircleCheckBig
              color={brandPrimaryColor}
              className="curai-mx-auto"
            />
            <h2 className="curai-text-lg curai-mt-5 curai-mb-0 curai-font-semibold  !curai-text-black ">
              Thank you <em>{customerName}</em> for your feedback!
            </h2>
            <p className="curai-mb-5 curai-mt-3 !curai-text-[#555454]">
              Your feedback is quite important to us. Please take a moment to
              rate us so we can help.
            </p>
            <Button
              variant="secondary"
              isIcon={true}
              className="curai-font-medium curai-w-fit curai-mx-auto curai-border-[2px] curai-text-[18px] curai-flex curai-float-right curai-items-center curai-justify-center curai-text-right"
              onClick={() => {
                handleCloseChat();
                clearChatLocalStorage();
              }}
              color={brandPrimaryColor}
              onMouseEnter={(e) => onHover(e)}
              onMouseLeave={(e) => onLeave(e)}
            >
              <span> Close Window</span>
            </Button>
          </div>
        ) : (
          (isAgentAssigned ||
            userAgentDetails.is_chat_complete ||
            isChatCompleted) && (
            <>
              <div
                onClick={handleBackToChat}
                ref={ref}
                className=" curai-font-medium curai-flex curai-flex-nowrap curai-justify-end curai-ml-auto curai-leading-none curai-relative curai-cursor-pointer curai-w-16 hover:curai-underline"
                style={{ textDecorationColor: brandPrimaryColor }}
              >
                <ChevronLeft
                  color={brandPrimaryColor}
                  className="curai-h-5 curai-absolute curai-top-[2px] curai-right-[45px] curai-w-5 curai-focus:ring-0 curai-focus:ring-transparent "
                />
                <span
                  className="curai-font-semibold  curai-text-lg  "
                  style={{
                    color: brandPrimaryColor,
                  }}
                >
                  Back
                </span>
              </div>
              <div className=" curai-mt-2">
                <div className="curai-w-full curai-text-center">
                  <h2 className="curai-text-lg curai-font-semibold !curai-text-black">
                    Was <em>{agentName}</em> helpful and helped you out with
                    your query?
                  </h2>
                  <p className="curai-text-md curai-text-gray-600 !curai-text-[#504E4E]">
                    Your feedback is quite important to us. Please take a moment
                    to rate us so we can help you better.
                  </p>
                </div>
                <div className="curai-flex curai-justify-center curai-gap-8 curai-p-2 curai-border-t">
                  <Button
                    variant="secondary"
                    isIcon={true}
                    className="curai-font-medium curai-border-[2px] curai-text-[18px] curai-flex curai-float-right curai-items-center curai-justify-center curai-text-right"
                    disabled={isFeedbackLoading || isDisconnectChatLoading}
                    color={brandPrimaryColor}
                    onMouseEnter={(e) => onHover(e)}
                    onMouseLeave={(e) => onLeave(e)}
                    onClick={() => handleFeedback(true, chatId, orgId)}
                  >
                    <ThumbsUp color={brandPrimaryColor} />
                    <span> Yes</span>
                  </Button>
                  <Button
                    isIcon={true}
                    disabled={isFeedbackLoading || isDisconnectChatLoading}
                    variant="secondary"
                    onClick={() => handleFeedback(false, chatId, orgId)}
                    className={`curai-font-medium curai-border-[2px] curai-text-[18px] curai-flex curai-float-right curai-items-center curai-justify-center curai-text-right`}
                    color={brandPrimaryColor}
                    onMouseEnter={(e) => onHover(e)}
                    onMouseLeave={(e) => onLeave(e)}
                  >
                    <ThumbsDown color={brandPrimaryColor} />
                    <span>No</span>
                  </Button>
                </div>
              </div>
              <div className="curai-h-10"></div>
            </>
          )
        )}
      </div>
    );
  }
);
